<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Branch</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/multibranchs/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>

    </main>
</template>



<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/MultiBranchs/MenuList.vue";
    import lang from "@/views/modules/MultiBranchs/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/MultiBranchs/SearchView.vue";
    export default {
        name: "new-categorys",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_BRANCH_NAME,
                        link: true,
                        moduleName: 'MultiBranchs',/// moduleName is required
                        routePath: 'multibranchs',/// routePath is required at start of object folder name
                        isSort: true,
                        field_name: 'name'
                    },
                    {
                        label: lang.LBL_STATUS,
                        link: false,
                        routePath: '',
                        isSort: true,
                        field_name: 'status'
                    },
                ],
                columns: ['name', 'status'],

            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns);
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>